import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-shopify-identity-credentials',
  templateUrl: './help-shopify-identity-credentials.component.html',
  styleUrls: ['./help-shopify-identity-credentials.component.scss']
})
export class HelpShopifyIdentityCredentialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
